









































































































































import Vue from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import dateFormat from '@/utils/dateFormat';
import { Shipment } from '@/models/shipment';
import { ErrorManager } from '@/models/error';
import ShipmentInvoice from './ShipmentInvoice.vue';
import { Account } from '@/models/account';
export default Vue.extend({
  name: 'Past-Shipment',
  components: { ShipmentInvoice },
  data() {
    return {
      search: '',
      errorMessage: '',
      loading: false
    };
  },

  computed: {
    ...mapState('shipment', ['shipment']),
    ...mapGetters({
      getAllShipments: 'shipment/getAllShipments'
    }),
    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    },
    userInfo() {
      return JSON.parse(localStorage.getItem('user')!);
    },
    pastShipments(): Shipment[] {
      const userId = this.userInfo == null ? null : this.userInfo.pk;
      return this.shipment.filter(
        (model: Shipment) =>
          model.status === 'P' &&
          model.user &&
          (model.user as Account).pk === userId
      );
    }
  },

  methods: {
    ...mapActions({
      fetchShipments: 'shipment/fetchShipments'
    }),
    dateFormat,

    filterShipmentObject(queryText: string) {
      console.log(queryText);
      const filter = this.pastShipments.filter((element: Shipment) => {
        return (
          element
            .description!.toLocaleLowerCase()
            .indexOf(queryText.toLocaleLowerCase()) > -1
        );
      });
      return filter;
    },

    openFileDialog(shipment: Shipment) {
      (this as any).$refs.shipmentinvoicedialog.open(shipment);
    },
    genShipment() {
      this.loading = true;
      this.fetchShipments()
        .catch((error: any) => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  mounted() {
    this.loading = true;
    this.fetchShipments()
      .catch((error: any) => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
});
